import { create } from 'zustand'
import { formularioSlice } from './slices/formularioSlice'
import { notificacionesSlice } from './slices/notificacionesSlice'

const useNotificacionesStore = create((set,get) => ({
    error:null,
    isLoading: true,
    elNavigate:null,
    datos: {
        id:0,
        titulo:"",
        subtitulo:"",
        estatus:1,
        tipo_notificacion: 1,
        id_sucursal:0,
        id_preferencia:0,
        tipo_dispositivo:0,
    },
    tipos_notificacion: [],
    sucursales: [],
    preferencias: [],
    dispositivos: [],
    handleSave: () => {
      get().insertarNotificacion();
    },
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    iniciar: async() => {    
        await get().obtenerOpcionesNotificacion();
        set({ isLoading: false });
    },
    limpiar: () => {
      set({
        isLoading: true,
        datos: {
          id:0,
          titulo:"",
          subtitulo:"",
          estatus:1,
          tipo_notificacion: 1,
          id_sucursal:0,
          id_preferencia:0,
          tipo_dispositivo:0,
        },
        elNavigate:null,
        error:null,
      })
    },
    ...formularioSlice(set,get),
    ...notificacionesSlice(set,get),
}))
  
export default useNotificacionesStore
